import { VProgressLinear } from 'vuetify/lib/components/VProgressLinear';

var render = function render(){var _vm=this,_c=_vm._self._c;return (_vm.loading)?_c(VProgressLinear,{attrs:{"indeterminate":_vm.loading,"color":"success","height":"5"}}):_vm._e()
}
var staticRenderFns = []

export { render, staticRenderFns }